import BillingsCargoTaxiUpdateStatusParams from "../../../../../common/services/billings/cargo-taxi/update-status/billings-cargo-taxi-update-status-params";
import BillingStatus from "../../../types/billing-status";
import { ActionOption } from "../types/action-option";

const setBillingStatus = (action: ActionOption): BillingStatus => {
  switch (action) {
    case ActionOption.ACCEPT:
      return BillingStatus.ACCEPTED;
    case ActionOption.REJECT:
      return BillingStatus.REJECTED;
    case ActionOption.REOPEN:
      return BillingStatus.REOPENED;
    case ActionOption.SEND_REQUEST_TO_REOPEN:
      return BillingStatus.REOPEN_REQUEST;
  }
};

const createUpdateBillingStatusRequest = (
  billingUuid: string,
  actionOption: ActionOption,
  comment?: string,
): BillingsCargoTaxiUpdateStatusParams => {
  const result: BillingsCargoTaxiUpdateStatusParams = {
    billingUuid: billingUuid,
    status: setBillingStatus(actionOption),
    comment: comment,
  };

  return result;
};

const billingStatusUpdateRequestFactory = {
  createUpdateBillingStatusRequest,
};

export default billingStatusUpdateRequestFactory;
